import React, { useMemo } from "react";
import ReactDOM from "react-dom";
import AppMenu from "components/presentation/main/menu/AppMenu";
import { useViewSlotNode } from "components/presentation/main/Main.lib.viewSlots";

// Mounts the side menu declared by the project's app inside the placeholder it rendered
// (`<div data-seed-menu="menu" />`, produced by the runtime's /helpers/Menu).
//
// Same arrangement as the chat portal: the menu stays in the host's React tree — where the
// user's solutions, the auth context and Apollo already are — while its DOM is a child of
// the app's own markup, so the app's layout sizes it natively.
//
// Whether the solution panel is open is NOT the menu's own state: the app can raise it too
// (/helpers/Menu's openMenu), so it is held one level up and handed down, and the menu's
// header reports its clicks back the same way the app's calls arrive.

const MenuPortal = ({ containerNode, slotId, menuProps, isStartShown, flow, setMenuOpen }) => {

  const selector = useMemo(() => `[data-seed-menu="${slotId}"]`, [slotId]);
  const targetNode = useViewSlotNode({ containerNode, selector });

  if (!targetNode || !targetNode.isConnected) return null;
  return ReactDOM.createPortal(
    <AppMenu
      flow={flow}
      {...menuProps}
      isStartShown={isStartShown}
      closeStart={() => setMenuOpen(slotId, false)}
      onClickToggleStart={() => setMenuOpen(slotId, null)}
    />,
    targetNode
  );
}

const MenuPortalManager = ({ containerNode, menus, openMenus, flow, setMenuOpen }) => {

  if (!containerNode || !menus) return null;

  return Object.entries(menus).map(([slotId, menuProps]) => (
    <MenuPortal
      key={slotId}
      containerNode={containerNode}
      slotId={slotId}
      menuProps={menuProps}
      isStartShown={Boolean(openMenus?.[slotId])}
      flow={flow}
      setMenuOpen={setMenuOpen}
    />
  ));
}

export default MenuPortalManager;
